var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}}),_vm._v(" "),_c('gallery',{ref:"gallery",attrs:{"gallery-class":"gallery"}}),_vm._v(" "),_c('banners',{staticClass:"mt-3",attrs:{"area":"content_bottom"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }